import { getEnv } from "./env";

export const msalConfig = {
  auth: {
    clientId: getEnv()?.clientId ?? "",
    authority: getEnv()?.authority,
    navigateToLoginRequestUrl: true,
    redirectUri: getEnv()?.redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (_level: any, _message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const tokenRequest = {
  scopes: ["Mail.Read"],
};

export const sessionKey = "crmMsalAuthSession";
export const sessionExpiryKey = "crmExpiryTime";
export const sessionExpiryTime = 60 * 60 * 1000;
export const authUpdatedEvent = "crm-auth-updated";
export const authSyncRequestEvent = "crm-auth-sync-request";
export const tokenRefreshStartedEvent = "crm-token-refresh-started";
export const tokenRefreshFinishedEvent = "crm-token-refresh-finished";
export const sessionExtendedEvent = "crm-session-extended";
export const sessionExtensionThrottleMs = 10 * 60 * 1000;
export const sessionExtensionMarkerKey = "crmLastSessionExtensionAt";
